import {CALL_API} from 'middleware/api';
import * as ActionTypes from '../PasswordRecovery.js';

export function beginPasswordRecovery() {
    return {type: ActionTypes.BEGIN_PASSWORD_RECOVERY};
}

export function cancelPasswordRecovery() {
    return {type: ActionTypes.CANCEL_PASSWORD_RECOVERY};
}

export function recoverPassword(data) {
    return {
        type: ActionTypes.RECOVER_PASSWORD,
        [CALL_API]: {
            endpoint: '/api/gambler/recover-password',
            method: 'post',
            types: [
                ActionTypes.SUCCESS_RECOVER_PASSWORD,
                ActionTypes.FAILURE_RECOVER_PASSWORD
            ],
            data
        }
    };
}

export function recoverPasswordViaPhone(data) {
    return {
        type: ActionTypes.PHONE_RECOVER_PASSWORD,
        [CALL_API]: {
            endpoint: '/api/gambler/phone-recover',
            method: 'post',
            types: [
                ActionTypes.SUCCESS_PHONE_RECOVER_PASSWORD,
                ActionTypes.FAILURE_PHONE_RECOVER_PASSWORD
            ],
            data
        }
    };
}



// WEBPACK FOOTER //
// ./js/actions/creators/PasswordRecovery.js